/**
 * Cart Discount Enhancer
 * 
 * This file enhances the existing xo-cart-discount-submit custom element
 * by adding additional functionality for discount code submission.
 */

(function() {
  // Wait for DOM to be ready
  document.addEventListener('DOMContentLoaded', function() {
    // Find all xo-cart-discount-submit elements
    const discountSubmitElements = document.querySelectorAll('xo-cart-discount-submit');
    
    // Enhance each element
    discountSubmitElements.forEach(enhanceDiscountSubmit);
  });
  
  // Listen for changes to the mini cart
  const observer = new MutationObserver(function() {
    // Find all xo-cart-discount-submit elements
    const discountSubmitElements = document.querySelectorAll('xo-cart-discount-submit');
    
    // Enhance each element
    discountSubmitElements.forEach(enhanceDiscountSubmit);
  });
  
  // Start observing the mini cart
  observer.observe(document.getElementById('xo-cart-mini'), {
    childList: true,
    subtree: true
  });


  // Function to enhance the discount submit element
  function enhanceDiscountSubmit(element) {
    // Check if element already has our enhancement
    if (element.hasAttribute('data-enhanced')) {
      return;
    }
    
    // Mark as enhanced to prevent double enhancement
    element.setAttribute('data-enhanced', 'true');
    
    // Find the parent form or xo-cart-discount element
    const container = element.closest('form') || element.closest('xo-cart-discount');
    if (!container) {
      return;
    }
    
    // Find the input field
    const inputField = container.querySelector('.xo-field-input__input[name="discount"]');
    if (!inputField) {
      console.error('CartDiscountEnhancer: No discount input field found');
      return;
    }
    
    // Create or find an error message element
    let errorElement = document.getElementById('xo-cart-discount-error');
    if (!errorElement) {
      errorElement = document.createElement('div');
      errorElement.id = 'xo-cart-discount-error';
      errorElement.classList.add('xo-cart-discount__error');
      errorElement.setAttribute('role', 'alert');
      errorElement.style.display = 'none';
      container.appendChild(errorElement);
    }
    
    // Add click event listener to the element
    element.addEventListener('click', function(event) {
      event.preventDefault();
      
      // Get the button inside the element
      const button = element.querySelector('.xo-btn');
      
      // Check if already submitting
      if (element.classList.contains('is-loading')) {
        return;
      }
      
      // Get the discount code
      const discountCode = inputField.value.trim();
      
      if (!discountCode) {
        showError('Please enter a discount code');
        return;
      }
      
      // Set loading state
      element.classList.add('is-loading');
      if (button) {
        button.classList.add('is-loading');
      }
      
      // Apply the discount
      applyDiscount(discountCode);
    });
    
    // Function to show error message
    function showError(message) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      
      // Hide error after 3 seconds
      setTimeout(() => {
        errorElement.style.display = 'none';
      }, 3000);
    }
    
    // Function to show success message
    function showSuccess(message) {
      errorElement.textContent = message;
      errorElement.style.display = 'block';
      errorElement.classList.add('success');
      
      // Hide message after 3 seconds
      setTimeout(() => {
        errorElement.style.display = 'none';
        errorElement.classList.remove('success');
      }, 3000);
    }
    
    // Function to apply discount
    function applyDiscount(code) {
      console.log('Attempting to apply discount code:', code);
      
      // Check if we're in a development environment
      const isDevelopment = window.location.hostname === 'localhost' || 
                           window.location.hostname === '127.0.0.1' ||
                           window.location.port === '8080';
      
      if (isDevelopment) {
        console.log('Development environment detected. Simulating discount application.');
        // In development, simulate a successful discount application
        setTimeout(() => {
          showSuccess('Discount applied successfully (simulated in development)');
          element.classList.remove('is-loading');
          const button = element.querySelector('.xo-btn');
          if (button) {
            button.classList.remove('is-loading');
          }
          // Clear the input field
          inputField.value = '';
        }, 1000);
        return;
      }
      
      // First, try to apply the discount code using the cart update endpoint
      console.log('Sending request to /cart/update.js');
      fetch(`/discount/${code}`).then(async () => {
        console.log('Discount applied successfully');
        showSuccess('Discount applied successfully');
        refreshCart();
      });
    }
    
    // Function to refresh the cart
    function refreshCart() {
      // First, fetch the updated cart data
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // Then fetch the cart drawer section HTML
          const cartDrawerSectionUrl = window.location.origin + '?section_id=xo-cart-mini';
          return fetch(cartDrawerSectionUrl)
            .then(response => response.text())
            .then(html => {
              const parser = new DOMParser();
              const doc = parser.parseFromString(html, 'text/html');
              
              // Find the cart drawer content in the response
              const cartDrawerContent = doc.querySelector('.xo-cart-mini-content__successfully');
              const cartDrawerFooter = doc.querySelector('.xo-cart-mini-footer');
              
              if (cartDrawerContent) {
                // Update the cart content
                const currentCartContent = document.querySelector('.xo-cart-mini-content__successfully');
                if (currentCartContent) {
                  currentCartContent.innerHTML = cartDrawerContent.innerHTML;
                }
              }
              
              if (cartDrawerFooter) {
                // Update the cart footer (which contains the discount list)
                const currentCartFooter = document.querySelector('.xo-cart-mini-footer');
                if (currentCartFooter) {
                  currentCartFooter.innerHTML = cartDrawerFooter.innerHTML;
                }
              }
              
              // Update any cart discount list elements
              const cartDiscountList = doc.querySelector('.xo-cart-discount-list');
              if (cartDiscountList) {
                const currentCartDiscountList = document.querySelector('.xo-cart-discount-list');
                if (currentCartDiscountList) {
                  currentCartDiscountList.innerHTML = cartDiscountList.innerHTML;
                }
              }
              
              // Clear the discount input field
              inputField.value = '';
              
              // Dispatch an event to notify that the cart was updated
              document.dispatchEvent(new CustomEvent('cart:updated', {
                detail: { cart: cart }
              }));
              
              // If we're in a modal or popover, try to close it
              const modalTrigger = document.querySelector('xo-modal-trigger');
              if (modalTrigger) {
                try {
                  modalTrigger.click();
                } catch (e) {
                  console.log('Could not close modal automatically');
                }
              }
              
              return cart;
            });
        })
        .then(cart => {
          // if cart page
          if (window.location.pathname === '/cart') {
            // reload
            location.reload();
          }
        })
        .catch(error => {
          console.error('Error refreshing cart:', error);
        });
    }
  }
})();
